import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="brand">
              <img src="/images/logo-aeii.jpg" alt="Logo AEII" className="brand-logo footer-brand-logo" />
              <span>
                AEII
                <small>Africa Economic Intelligence Institute</small>
              </span>
            </Link>
            <p>
              Institut panafricain dédié à la recherche, à l'intelligence économique
              et à la valorisation des connaissances stratégiques pour le développement
              du continent.
            </p>
            <div className="footer-social">
              <a href="#" aria-label="LinkedIn"><i className="fa-brands fa-linkedin-in"></i></a>
              <a href="#" aria-label="Twitter"><i className="fa-brands fa-x-twitter"></i></a>
              <a href="#" aria-label="Facebook"><i className="fa-brands fa-facebook-f"></i></a>
              <a href="#" aria-label="YouTube"><i className="fa-brands fa-youtube"></i></a>
            </div>
          </div>

          <div>
            <h4>Navigation</h4>
            <ul>
              <li><Link to="/a-propos">À propos de l'AEII</Link></li>
              <li><Link to="/intelligence-economique">Intelligence Économique</Link></li>
              <li><Link to="/publications">Bibliothèque de publications</Link></li>
              <li><Link to="/actualites">Actualités</Link></li>
            </ul>
          </div>

          <div>
            <h4>Compte</h4>
            <ul>
              <li><Link to="/abonnements">Nos formules d'abonnement</Link></li>
              <li><Link to="/inscription">Créer un compte</Link></li>
              <li><Link to="/connexion">Se connecter</Link></li>
              <li><Link to="/mon-compte">Mon espace</Link></li>
            </ul>
          </div>

          <div>
            <h4>Contact</h4>
            <ul>
              <li><i className="fa-solid fa-location-dot"></i>&nbsp; Bonapriso, Douala -Cameroun </li>
              <li><i className="fa-solid fa-envelope"></i>&nbsp; contact@aeii.online</li>
              <li><i className="fa-solid fa-phone"></i>&nbsp; +237 679 267 502 / +237 692 406 812</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>&copy; 2026 AEII – Africa Economic Intelligence Institute. Tous droits réservés.</span>
          <span>Plateforme de recherche, intelligence économique &amp; publication scientifique.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;